export const projectPurchaseQuery = (projectId, lazyParams) => {
  const params = new URLSearchParams();
  params.set('search[project][operator]', '=');
  params.set('search[project][value]', String(projectId));
  if (lazyParams.sortField) params.set('sort', lazyParams.sortField.toLowerCase().replaceAll('.', '_'));
  params.set('direction', lazyParams.sortOrder === 1 ? 'asc' : 'desc');
  params.set('item_per_page', String(lazyParams.rows));
  params.set('page', String((lazyParams.page || 0) + 1));
  Object.entries(lazyParams.filters || {}).forEach(([field, filter]) => {
    if (filter?.value == null || filter.value === '') return;
    const key = field.replaceAll('.', '_');
    params.set(`search[${key}][operator]`, filter.matchMode === 'equals' ? '=' : 'like');
    params.set(`search[${key}][value]`, String(filter.value));
  });
  return params.toString();
};
